import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { AppBar, Grid, Link, Toolbar, Typography } from "@mui/material";
import "./Common.css";
import { checkMultiStore } from "./utils";
import { useThemeColor } from "../hooks/useThemeColor";

const Footer = () => {
  const { themeColor } = useThemeColor();
  const { endpoint } = useSelector((state) => state.auth);

  const fontColor = useMemo(() => {
    return checkMultiStore(endpoint) ? "#ffffff" : "#000000";
  }, [endpoint]);

  const { termsURL, privacyURL } = useMemo(() => {
    return {
      termsURL: `https://${endpoint}.feedthetummy.com/page/terms`,
      privacyURL: `https://${endpoint}.feedthetummy.com/page/privacy-policy`,
    };
  }, [endpoint]);

  return (
    <AppBar
      position="absolute"
      color={"default"}
      className="footer"
      elevation={0}
      sx={{
        position: "relative",
        // backgroundColor: themeColor,
        backgroundColor: checkMultiStore(endpoint) ? themeColor : undefined,

        // borderBottom: (t) => `1px solid ${t.palette.divider}`,
      }}
    >
      <Toolbar
        className="container footer-content d-flex justify-content-center"
        sx={{
          justifyContent: "space-between",
          minHeight: 150,
        }}
      >
        <Grid
          container
          rowGap={2}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
            xl={4}
            display={"flex"}
            alignItems={"flex-start"}
            justifyContent={"center"}
          >
            <Typography
              sx={{
                fontSize: 16,
                color: fontColor,
              }}
            >
              Copyright @{" "}
              <Link
                href="/"
                sx={{
                  fontSize: 16,
                  color: fontColor,
                  textTransform: "capitalize",
                  "&:hover": {
                    color: fontColor,
                  },
                }}
              >
                {endpoint}
              </Link>
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
            xl={4}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Typography
              sx={{
                fontSize: 16,
                color: fontColor,
              }}
            >
              <Link
                href={termsURL}
                target="_blank"
                sx={{
                  fontSize: 16,
                  color: fontColor,
                  textDecorationColor: `${fontColor}40`,
                  "&:hover": {
                    color: fontColor,
                  },
                }}
              >
                Terms
              </Link>{" "}
              |{" "}
              <Link
                href={privacyURL}
                target="_blank"
                sx={{
                  fontSize: 16,
                  color: fontColor,
                  "&:hover": {
                    color: fontColor,
                  },
                }}
              >
                Privacy Policy
              </Link>
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
            xl={4}
            display={"flex"}
            alignItems={"flex-end"}
            justifyContent={"center"}
          >
            <Typography
              sx={{
                fontSize: 16,
                color: fontColor,
              }}
            >
              {"Powered by "}
              <Link
                href={"https://www.skiptheq.co.uk"}
                target="_blank"
                sx={{
                  fontSize: 16,
                  color: fontColor,
                  fontWeight: "700",
                  textDecoration: "underline",
                  "&:hover": {
                    color: fontColor,
                  },
                }}
              >
                SkipTheQ
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default Footer;
